module.exports = __webpack_public_path__ + "b269b108f8790389c5bb113ab8fd0670.pdf";